
import { Component, Watch } from 'vue-property-decorator';

import Booking from '@/views/Booking.vue';

import { MetaInfo } from 'vue-meta';

import { HotelsApi } from '@/api/HotelsApi';

import { allAccByUuidParams } from '@/interfaces/Hotels';

import { first, sortBy } from 'lodash';

import { mapState } from 'vuex';

@Component({
   computed: {
      ...mapState({
         activities_colors: (s: any) => s.activities.colors,
      }),
   },
   metaInfo(): MetaInfo {
      return {
         title: 'Shared accommodation report for accommodation',
      };
   },
   filters: {
      formatDate: (act_day: any) => (act_day != null ? new Date(act_day * 8.64e7).toISOString() : ''),
      roomType: (room_types: any[], room_type_id: string) =>
         room_type_id ? first(room_types.filter(a => parseInt(a.d_id) == parseInt(room_type_id)))?.d_name : '',
   },
})
export default class AccommodationReport extends Booking {
   stripos!: any;

   addColorTooltips!: any;

   modalData: any = {
      name: '',
      comment: '',
   };

   modalError: any = {
      name: false,
      comment: false,
   };

   room_types: any[] = [];

   activities_colors!: any[];

   dateRange: Date[] = [];

   customFormatter!: any;

   formatTime!: any;

   operationName: any = '';

   fields: any[] = [];

   items: any[] = [];

   filtered: any[] = [];

   filter: any = {
      acс_status: '#ffffff',
      moto_lead_guest: '',
      acс_number_rooms: '',
      acс_room_type_id: '',
      acс_checkin_date: '',
      acс_nts: '',
      acс_cost: '',
      acс_supp_name: '',
      moto_acс_form: '',
   };

   created(): void {
      /*
      if (!this.$route.query.dateFrom || !this.$route.query.dateTo) {
         return;
      }

      this.dateRange = [this.$moment(this.$route.query.dateFrom).toDate(), this.$moment(this.$route.query.dateTo).toDate()];
      */

      this.operationName = this.$route.query.operationName;

      this.fields = [
         {
            key: 'acс_status',
            label: 'status',
            thAttr: {
               style: 'width: 120px;',
            },
         },
         {
            key: 'moto_lead_guest',
            sortable: true,
            label: 'Lead Guest',
            tdAttr: {
               style: 'text-align: center;',
            },
         },
         {
            key: 'moto_our_reference',
            sortable: true,
            label: 'GROUP REFERENCE',
            tdAttr: {
               style: 'text-align: center;',
            },
            thAttr: {
               style: 'width: 50px;',
            },
         },
         {
            key: 'acс_supp_name',
            sortable: true,
            label: 'Accommodation',
            tdAttr: {
               style: 'text-align: center;',
            },
         },
         {
            key: 'acс_number_rooms',
            sortable: true,
            label: 'Number of Rooms',
            tdAttr: {
               style: 'text-align: center;',
            },
         },
         {
            key: 'acс_room_type_id',
            sortable: true,
            label: 'Room Type',
            tdAttr: {
               style: 'text-align: center;',
            },
            formatter: (o_id: number) => first(this.room_types.filter(d => d.d_id == o_id))?.d_name,
         },
         {
            key: 'acс_checkin_date',
            sortable: true,
            label: 'Check-in Date',
            tdAttr: {
               style: 'text-align: center;',
            },
         },
         {
            key: 'acс_nts',
            sortable: true,
            label: 'Nights',
            tdAttr: {
               style: 'text-align: center;',
            },
         },
         {
            key: 'acс_cost',
            sortable: true,
            label: 'Cost €',
            tdAttr: {
               style: 'text-align: center;',
            },
         },
         {
            key: 'moto_acс_form',
            label: 'ACCOMMODATION FORM',
            tdAttr: {
               style: 'text-align: center;',
            },
         },
      ];
   }

   mounted(): void {
      this.getData();
   }

   getData() {
      const params: allAccByUuidParams = {
         uuid: this.$route.params.id,
         //fromDate: this.$moment(this.dateRange[0]).format('YYYY-MM-DD'),
         //toDate: this.$moment(this.dateRange[1]).format('YYYY-MM-DD'),
         fromDate: this.$moment()
            .subtract(2, 'month')
            .format('YYYY-MM-DD'),
         toDate: this.$moment(this.$moment().format('YYYY') + '-12-31')
            .add(1, 'year')
            .format('YYYY-MM-DD'),
      };

      if (!params.fromDate || !params.toDate) return;

      this.$store.commit('showLoading');
      this.$store.commit('setItems', { name: 'ready', value: false });
      HotelsApi.allAccByUuid(params)
         .then(data => {
            this.items = sortBy(
               data['Accommodation by date'].filter((c: any) => c.acс_status !== 'FF2D00'),
               'acс_checkin_date'
            );
            const titleEl: any = document.querySelector('head title');
            titleEl.textContent = 'Shared accommodation report for accommodation - ' + this.operationName;
            this.room_types = sortBy(data['dic_room_type'], 'o_name');
            this.addColorTooltips(['.orders-list'], this.activities_colors);
         })
         .finally(() => {
            this.filterData();
            this.$store.commit('setItems', { name: 'ready', value: true });
            this.$store.commit('hideLoading');
         });
   }

   accommodationConfirmation(item: any) {
      if ([1993, 2113, 1996].includes(parseInt(item.acс_status_id))) {
         this.modalData = { ...item, name: '', comment: '' };
         this.modalError = {
            ...this.modalError,
            name: false,
            comment: false,
         };
         this.$bvModal.show('accommodation-confirmation-modal');
      }
   }

   submitAccommodation(type: string) {
      if (this.validated(type)) {
         this.$store.commit('showLoading');
         switch (type) {
            case 'accept':
               HotelsApi.acceptAccommodation(this.modalData)
                  .then(response => {
                     if (response.data == 1) {
                        this.$bvModal.hide('accommodation-confirmation-modal');
                        this.$bvToast.toast('Success', {
                           title: '',
                           variant: 'success',
                           solid: true,
                        });
                        setTimeout(() => {
                           window.location.reload();
                        }, 3000);
                     } else {
                        this.$bvToast.toast(response.data, {
                           title: 'Error',
                           variant: 'danger',
                           solid: true,
                        });
                     }
                  })
                  .finally(() => {
                     this.$store.commit('hideLoading');
                  });
               break;
            case 'decline':
               HotelsApi.rejectAccommodation(this.modalData)
                  .then(response => {
                     if (response.data == 1) {
                        this.$bvModal.hide('accommodation-confirmation-modal');
                        this.$bvToast.toast('Success', {
                           title: '',
                           variant: 'success',
                           solid: true,
                        });
                        setTimeout(() => {
                           window.location.reload();
                        }, 3000);
                     } else {
                        this.$bvToast.toast(response.data, {
                           title: 'Error',
                           variant: 'danger',
                           solid: true,
                        });
                     }
                  })
                  .finally(() => {
                     this.$store.commit('hideLoading');
                  });
               break;
         }
      }
   }

   validated(type: string) {
      if (type == 'accept' && !this.modalData.name) {
         this.modalError.name = true;
         return;
      }
      if (type == 'decline' && (!this.modalData.name || !this.modalData.comment)) {
         this.modalError.name = true;
         this.modalError.comment = true;
         return;
      }
      return true;
   }

   filterData() {
      let filter: any;
      filter = {
         acс_status: '#ffffff',
         moto_lead_guest: '',
         acс_number_rooms: '',
         acс_room_type_id: '',
         acс_checkin_date: '',
         acс_nts: '',
         acс_cost: '',
         acс_supp_name: '',
         moto_acс_form: '',
         ...this.filter,
      };
      this.filtered = this.items.filter(a => {
         const room_type = first(this.room_types.filter(g => g.d_id == a.acс_room_type_id));
         return (
            (['#ffffff', 'ffffff'].includes(filter['acс_status'].toLowerCase()) || this.stripos(a.acс_status, filter['acс_status'])) &&
            (filter.moto_lead_guest === '' || this.stripos(a.moto_lead_guest, filter.moto_lead_guest)) &&
            (filter.acс_nts === '' || this.stripos(a.acс_nts, filter.acс_nts)) &&
            (filter.acс_cost === '' || this.stripos(a.acс_cost, filter.acс_cost)) &&
            (filter.acс_supp_name === '' || this.stripos(a.acс_supp_name, filter.acс_supp_name)) &&
            (filter.moto_acс_form === '' || this.stripos(a.moto_acс_form, filter.moto_acс_form)) &&
            (filter.acс_number_rooms === '' || this.stripos(a.acс_number_rooms, filter.acс_number_rooms)) &&
            (filter.acс_room_type_id === '' || this.stripos(room_type?.d_name, filter.acс_room_type_id)) &&
            ([null, '', 'Invalid date'].includes(filter['acс_checkin_date']) ||
               this.$moment(a.acс_checkin_date).format('YYYYDDMM') === this.$moment(filter['acс_checkin_date']).format('YYYYDDMM'))
         );
      });
   }

   @Watch('dateRange', { immediate: false, deep: true })
   onChangeDateRange(n: string) {
      let query = this.$route.query;

      if (n.length) {
         this.$localStorage.setItem('activities-list.startDate', n[0]);
         this.$localStorage.setItem('activities-list.endDate', n[1]);

         query['dateFrom'] = this.$moment(n[0]).format('YYYY-MM-DD');
         query['dateTo'] = this.$moment(n[1]).format('YYYY-MM-DD');
      }

      this.$router.push({ query }).catch(() => {});
      this.getData();
   }

   @Watch('filter', { immediate: true, deep: true })
   changeFilter(filter: any, old: any) {
      const query = { ...this.$route.query, ...filter };

      if (query['acс_checkin_date'] !== '') {
         query['acс_checkin_date'] = this.$moment(query['acс_checkin_date']).format();
      }

      this.$router.push({ query }).catch(() => {});
      this.filterData();
   }

   @Watch('filter_transfer', { immediate: true, deep: true })
   changeFilterTransfer(filter_transfer: any, old: any) {
      const query = { ...this.$route.query, ...filter_transfer };

      if (query['acс_checkin_date'] !== '') {
         query['acс_checkin_date'] = this.$moment(query['acс_checkin_date']).format();
      }

      this.$router.push({ query }).catch(() => {});
      this.filterData();
   }
}
